module.exports = __webpack_public_path__ + "media/images/sp/top/catch-90977958fd2f1babfd58a366ac9907ea.png";